import axios from "axios";
export default container => {
    container.declare("arcologyClient", ({i18n, settings}) => {
        // create an instance of axios preconfigured for arcology api calls
        const arcologyClient = axios.create({
            baseURL: process.env.VUE_APP_ARCOLOGY_API_BASE_PATH,
        });

        arcologyClient.interceptors.request.use(config => {
            config.headers["x-sah-api-key"] =
                settings.apiKey && settings.apiKey !== "" ? settings.apiKey : localStorage.getItem("ARCOLOGY.apiKey");
            config.headers["Accept-Language"] = i18n.locale;
            return config;
        });

        return arcologyClient;
    });
};
